// extracted by mini-css-extract-plugin
export default {"taskWrapper":"five-moments-hand-hygiene_taskWrapper__5aOp9"};